import React from 'react'
import Navigation from '../../components/navigation/navigation'
import Footer from '../../components/footer/footer'
import Container from '../../components/container/container'
import request from '../../helpers/request';
import { matchPath, withRouter } from 'react-router-dom';
import endpoints from '../../helpers/endpoints';
import Card from '../../components/card/card';
import Checkbox from '@mui/material/Checkbox';
import { UserMap } from './batchProcesses/UserMap';

export default withRouter(({ ...props }) => {
  const match = matchPath(props.history.location.pathname, {
    path: '/admin/portal/companies/:company/batch-processes',
  })
  const { params } = match;
  const companyId = params.company;
  const [companyConfig, setCompanyConfig] = React.useState(null);
  const [products, setProducts] = React.useState([]);
  const [productConfigs, setProductConfigs] = React.useState([]);

  const loadData = () => {
    request(true).get(endpoints.ADMIN_COMPANIES_COMPANY + '/' + companyId + '/products').then(r => {
      let productOfferings = r.data.products;
      request(true).get(endpoints.PRODUCTS).then(r => {
        productOfferings = productOfferings.filter(productOffering => r.data.find(realProduct => realProduct.id == productOffering.id).available)

        productOfferings = productOfferings.map(productOffering => ({
          ...productOffering,
          type: r.data.find(realProduct => realProduct.id == productOffering.id).product_type,
        }))
        setProducts(productOfferings)
      })
    })
    request(true).get(endpoints.ADMIN_COMPANIES_COMPANY + '/' + companyId + '/batch-config').then(r => {
      setCompanyConfig(r.data)
    })
    request(true).get(endpoints.ADMIN_COMPANIES_COMPANY + '/' + companyId + '/product-batch-configs').then(r => {
      setProductConfigs(r.data)
    })
  }

  const updateBatchConfigState = e => {
    const { name, value, type, checked } = e.target;
    setCompanyConfig(prevState => ({
      ...(prevState || {}),
      [name]: type === 'checkbox' ? checked : value || '',
    }));
  };

  const updateNotificationUserField = React.useCallback((event, index, field) => {
    const { value } = event.target;

    setCompanyConfig(prevState => {
      const previousNotificationUsers = Object.entries(prevState?.notification_users || {});
      const currentEntry = previousNotificationUsers[index] || ['', ''];
      const updatedEntry = field === 'name'
        ? [value, currentEntry[1]]
        : [currentEntry[0], value];

      previousNotificationUsers[index] = updatedEntry;

      return {
        ...(prevState || {}),
        notification_users: Object.fromEntries(previousNotificationUsers),
      };
    });
  }, []);

  const addNotificationUser = React.useCallback(() => {
    setCompanyConfig(prevState => {
      const previousNotificationUsers = Object.entries(prevState?.notification_users || {});
      previousNotificationUsers.push(['', '']);

      return {
        ...(prevState || {}),
        notification_users: Object.fromEntries(previousNotificationUsers),
      };
    });
  }, []);

  const removeNotificationUser = React.useCallback(index => {
    setCompanyConfig(prevState => {
      const previousNotificationUsers = Object.entries(prevState?.notification_users || {});
      previousNotificationUsers.splice(index, 1);

      return {
        ...(prevState || {}),
        notification_users: Object.fromEntries(previousNotificationUsers),
      };
    });
  }, []);

  const batchConfigSubmit = () => {
    request(true).post(endpoints.ADMIN_COMPANIES_COMPANY + '/' + companyId + '/batch-config', {
      s3_api_var_path: companyConfig.s3_api_var_path,
      client: companyConfig.client,
      test_env: companyConfig.test_env,
      s3_local_path: companyConfig.s3_local_path,
      bd_portal: companyConfig.bd_portal,
      extra_baa_file: companyConfig.extra_baa_file,
      api_name: companyConfig.api_name,
      stage_name: companyConfig.stage_name,
      notification_users: companyConfig.notification_users,
    }).catch(e => {
      console.error(e);
    })
  }

  const updateProductConfigState = React.useCallback(e => {
    const { name, value, type, checked } = e.target;

    const productId = parseInt(name.substr(0, name.indexOf('_')));
    const existingConfigIndex = productConfigs.findIndex(config => config?.product_offering_id === productId);

    if (existingConfigIndex !== -1) {
      const updatedConfig = { ...productConfigs[existingConfigIndex], [name.substr(name.indexOf('_') + 1)]: type === 'checkbox' ? checked : value };
      setProductConfigs(prevState => {
        const updatedConfigs = [...prevState];
        updatedConfigs[existingConfigIndex] = updatedConfig;
        return updatedConfigs;
      });
    } else {
      const newConfig = {
        product_offering_id: productId,
        [name.substr(name.indexOf('_') + 1)]: type === 'checkbox' ? checked : value,
      };
      setProductConfigs(prevState => [...prevState, newConfig]);
    }
  }, [productConfigs])

  const productConfigSubmit = React.useCallback(() => {
    // const config = productConfigs.find(productConfig => productConfig.product_offering_id === item)
    request(true).post(endpoints.ADMIN_COMPANIES_COMPANY + '/' + companyId + '/product-batch-configs',
      productConfigs,
    ).catch(e => {
      console.error(e);
    })
  }, [productConfigs])

  React.useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="grid grid-gap-20">
      <Navigation />
      <Container>
        <div className="flex middle">
          <p className="colour-secondary font-weight-600" style={{ fontSize: 20 }}>Batch Processes - Company Config</p>
        </div>
        <Card>
          <div style={{ marginBottom: '15px' }} className="grid grid-columns-2 grid-gap-15">
            <div className="form-row">
              <label htmlFor="s3_api_var_path">S3 API Variables Path:</label>
              <input onChange={updateBatchConfigState} name="s3_api_var_path" className="input" type="text" value={companyConfig?.s3_api_var_path || ''} required />
            </div>
            <div className="form-row">
              <label htmlFor="s3_local_path">S3 Local Path:</label>
              <input onChange={updateBatchConfigState} name="s3_local_path" className="input" type="text" value={companyConfig?.s3_local_path || ''} required />
            </div>
            <div className="form-row">
              <label htmlFor="api_name">API Name:</label>
              <input onChange={updateBatchConfigState} name="api_name" className="input" type="text" value={companyConfig?.api_name || ''} required />
            </div>
            <div className="form-row">
              <label htmlFor="stage_name">Stage Name:</label>
              <input onChange={updateBatchConfigState} name="stage_name" className="input" type="text" value={companyConfig?.stage_name || ''} required />
            </div>
            <div className="form-row">
              <label htmlFor="test_env">Test Environment:</label>
              <input onChange={updateBatchConfigState} name="test_env" className="input" type="text" value={companyConfig?.test_env || ''} required />
            </div>
          </div>
          <UserMap
            notificationUsers={companyConfig?.notification_users || {}}
            onNotificationUserFieldChange={updateNotificationUserField}
            onNotificationUserAdd={addNotificationUser}
            onNotificationUserRemove={removeNotificationUser}
          />
          <div className="grid grid-gap-15">
            <button onClick={() => batchConfigSubmit()} disabled={!companyConfig} className="button background-primary colour-white">Update</button>
          </div>
        </Card>
        <div className="flex middle">
          <p className="colour-secondary font-weight-600" style={{ fontSize: 20 }}>Batch Processes - Product Config</p>
        </div>
        <div className='grid grid-columns-1 grid-gap-10'>
          <div className="form-row">
            <strong>BD Portal Products</strong>
            <ProductTable products={products} productConfigs={productConfigs} onChange={updateProductConfigState} />
            <button onClick={productConfigSubmit} className="button background-primary colour-white">Update</button>
          </div>
        </div>
      </Container>
      <Footer />
    </div>
  )
})

const ProductTable = React.memo(({ products, productConfigs, onChange }) => (
  <table className="table borders permissions">
    <thead>
      <tr>
        <th>Product</th>
        <th>Run BAA</th>
        <th>Run VACA</th>
        <th>Run MCV</th>
        <th>Run OS</th>
        <th>Client Email Return</th>
      </tr>
    </thead>
    <tbody>
      {products.filter(product => product.enabled === true && product.product_key)
        .sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        }).map(product => {
          const config = productConfigs?.find(config => config?.product_offering_id === product.id)
          return (
            <tr key={product.id}>
              <td>{product.name}</td>
              {
                ['run_baa', 'run_vaca', 'run_mcv', 'run_os', 'client_email_return'].map(key => {
                  return (
                    <td key={key}>
                      <Checkbox
                        name={`${product.id}_${key}`}
                        checked={!!(config && config[key])}
                        onChange={onChange}
                        color="primary"
                      />
                    </td>
                  )
                }
                )}
            </tr>
          );
        })
      }
    </tbody>
  </table>
));
